import { render, staticRenderFns } from "./OutStockDetail.vue?vue&type=template&id=4712a016"
import script from "./OutStockDetail.vue?vue&type=script&lang=js"
export * from "./OutStockDetail.vue?vue&type=script&lang=js"
import style0 from "./OutStockDetail.vue?vue&type=style&index=0&id=4712a016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports